import sortBy from "lodash/sortBy";
import { handleActions } from "redux-actions";

import { reorder } from "utils/array";
import removeById from "utils/removeById";

const updateAttachment = (attachments, attachment) =>
  attachments.map((a) => {
    if (a.id === attachment.id) return { ...a, ...attachment };

    return { ...a };
  });

export default handleActions(
  {
    ASSET_ATTACHMENTS_GET: {
      PENDING: () => ({
        assetAttachments: [],
      }),
      FULFILLED: (_, { payload: { attachments } }) => ({
        assetAttachments: sortBy(attachments, ["position"]),
      }),
    },

    ASSET_ATTACHMENT_CREATE: {
      PENDING: ({ assetAttachments }, { meta: { file } }) => ({
        assetAttachments: [
          ...assetAttachments,
          { isUploading: true, name: file.name, type: file.type },
        ],
      }),

      REJECTED: ({ assetAttachments }, { meta: { file } }) => ({
        assetAttachments: assetAttachments.map((attachment) => {
          if (attachment.name === file.name && attachment.isUploading) {
            return { ...attachment, error: true };
          }

          return { ...attachment };
        }),
      }),

      FULFILLED: ({ assetAttachments }, { meta: { file }, payload: { attachment } }) => ({
        assetAttachments: assetAttachments.map((f) => {
          if (file.name === f.name && f.isUploading) {
            return { ...f, ...attachment, isUploading: false };
          }

          return { ...f };
        }),
      }),
    },

    ASSET_ATTACHMENT_UPDATE: {
      FULFILLED: ({ assetAttachments }, { payload: { attachment } }) => ({
        assetAttachments: updateAttachment(assetAttachments, attachment),
      }),
    },

    ASSET_ATTACHMENT_DELETE: {
      PENDING: ({ assetAttachments }, { meta: { attachmentID } }) => ({
        assetAttachments: removeById(assetAttachments, attachmentID),
      }),
    },

    ASSET_ATTACHMENT_REORDER: ({ assetAttachments }, { meta: { newIndex, oldIndex } }) => ({
      assetAttachments: reorder(assetAttachments, oldIndex, newIndex),
    }),
  },
  {},
  { namespace: "_" }
);
